export default __webpack_public_path__ + "static/media/Kyocera.54df9d28.png";